export const it = {
    nav: {
        dashboard: 'Pannello',
        board: 'Board',
        list: 'Lista',
        settings: 'Impostazioni',
        reports: 'Report',
        myTasks: 'Le mie attività',
        activity: 'Attività',
        charts: 'Grafici',
        team: 'Team',
        timeTracking: 'Gestione del tempo',
        admin: 'Amministrazione',
        adminOverview: 'Panoramica admin',
        userManagement: 'Gestione utenti',
        projectSetup: 'Configurazione progetto',
    },
    common: {
        projectManMD: 'ProjectManMD',
        markdownProjectManagement: 'Gestione progetti Markdown',
        version: 'Versione',
        back: 'Indietro',
        loading: 'Caricamento...',
        noData: 'Nessun dato',
        search: 'Cerca',
        filter: 'Filtra',
        all: 'Tutto',
        close: 'Chiudi',
        open: 'Apri',
        connect: 'Connetti',
        archived: 'Archiviato',
        inactive: 'Inattivo',
        active: 'Attivo',
        untitled: 'Senza titolo',
        unknown: 'Sconosciuto',
        tasks: 'Attività',
        done: 'Completato',
        lastModified: 'Ultima modifica',
        created: 'Creato',
        points: 'Punti',
        pts: 'punti',
        yes: 'Sì',
        no: 'No',
        or: 'o',
    },
    actions: {
        create: 'Crea',
        edit: 'Modifica',
        delete: 'Elimina',
        save: 'Salva',
        cancel: 'Annulla',
        confirm: 'Conferma',
        add: 'Aggiungi',
        remove: 'Rimuovi',
        update: 'Aggiorna',
        close: 'Chiudi',
        submit: 'Invia',
        reset: 'Reimposta',
        load: 'Carica',
        export: 'Esporta',
        import: 'Importa',
        archive: 'Archivia',
        restore: 'Ripristina',
        deactivate: 'Disattiva',
        activate: 'Attiva',
    },
    auth: {
        signIn: 'Accedi',
        signOut: 'Esci',
        signUp: 'Registrati',
        username: 'Nome utente',
        password: 'Password',
        confirmPassword: 'Conferma password',
        displayName: 'Nome visualizzato',
        email: 'Email',
        role: 'Ruolo',
        createAccount: 'Crea account',
        dontHaveAccount: 'Non hai un account?',
        alreadyHaveAccount: 'Hai già un account?',
        signInToAccount: 'Accedi al tuo account',
        createYourAccount: 'Crea il tuo account',
        enterUsername: 'Inserisci il tuo nome utente',
        enterPassword: 'Inserisci la tua password',
        chooseUsername: 'Scegli un nome utente',
        yourFullName: 'Il tuo nome completo',
        atLeast6Chars: 'Almeno 6 caratteri',
        confirmPasswordPlaceholder: 'Conferma la tua password',
        pleaseEnterCredentials: 'Inserisci nome utente e password',
        invalidCredentials: 'Nome utente o password non validi',
        pleaseFillAllFields: 'Compila tutti i campi',
        passwordsDoNotMatch: 'Le password non corrispondono',
        passwordTooShort: 'La password deve avere almeno 6 caratteri',
        usernameExists: 'Il nome utente esiste già',
        demoCredentials: 'Credenziali demo',
        admin: 'Amministratore',
        manager: 'Manager',
        developer: 'Sviluppatore',
        viewer: 'Visualizzatore',
        contactAdminForRole: 'Contatta l\'amministratore per cambiare il ruolo',
        usernameCannotBeChanged: 'Il nome utente non può essere modificato',
    },
    statuses: {
        backlog: 'Backlog',
        todo: 'Da fare',
        inProgress: 'In corso',
        inReview: 'In revisione',
        done: 'Completato',
        planned: 'Pianificato',
        inProgressSprint: 'In corso (Sprint)',
        completed: 'Completato',
        allStatus: 'Tutti gli stati',
    },
    priorities: {
        critical: 'Critica',
        high: 'Alta',
        medium: 'Media',
        low: 'Bassa',
    },
    messages: {
        noProjects: 'Nessun progetto ancora',
        noTasks: 'Nessuna attività',
        confirmDelete: 'Sei sicuro di voler eliminare questo elemento?',
        saved: 'Salvato con successo',
        error: 'Si è verificato un errore',
        noTasksAssigned: 'Nessuna attività assegnata a te',
        noActivityYet: 'Nessuna attività ancora',
        confirmReset: 'Questo ripristinerà tutti i dati allo stato iniziale. Continuare?',
        removeUserConfirm: 'Sei sicuro di voler rimuovere questo utente?',
        deleteProjectConfirm: 'Sei sicuro di voler eliminare questo progetto?',
        archiveProjectConfirm: 'Sei sicuro di voler archiviare questo progetto?',
    },
    settings: {
        title: 'Impostazioni',
        theme: 'Tema',
        language: 'Lingua',
        languageAndRegion: 'Lingua e regione',
        gitConfig: 'Configurazione Git',
        gitIntegration: 'Integrazione Git',
        gitProvider: 'Fornitore Git',
        repositoryUrl: 'URL del repository',
        seedData: 'Dati di esempio',
        seedDataDescription: 'Carica progetti di esempio con attività, sprint ed epic per i test. Questo ripristinerà tutti i dati allo stato iniziale.',
        loadSeedData: 'Carica dati di esempio',
        seedDataConfirm: 'Questo ripristinerà tutti i dati allo stato iniziale. Continuare?',
        appearance: 'Aspetto',
        notifications: 'Notifiche',
    },
    themes: {
        summer: 'Estate',
        spring: 'Primavera',
        autumn: 'Autunno',
        winter: 'Inverno',
        day: 'Giorno',
        night: 'Notte',
        summerDay: 'Giorno d\'estate',
        summerNight: 'Notte d\'estate',
        springDay: 'Giorno di primavera',
        springNight: 'Notte di primavera',
        autumnDay: 'Giorno d\'autunno',
        autumnNight: 'Notte d\'autunno',
        winterDay: 'Giorno d\'inverno',
        winterNight: 'Notte d\'inverno',
        highContrast: 'Alto contrasto',
        selectTheme: 'Seleziona tema',
    },
    time: {
        hours: 'ore',
        minutes: 'minuti',
        days: 'giorni',
        weeks: 'settimane',
        justNow: 'adesso',
        minutesAgo: '{{count}}m fa',
        hoursAgo: '{{count}}h fa',
        daysAgo: '{{count}}g fa',
        updatedAt: 'Aggiornato',
    },
    reports: {
        velocity: 'Velocità',
        burndown: 'Burndown',
        burnup: 'Burnup',
        cycleTime: 'Tempo di ciclo',
        leadTime: 'Tempo di consegna',
        throughput: 'Produzione',
        gantt: 'Gantt',
        cumulativeFlow: 'Flusso cumulativo',
    },
    globalSearch: {
        placeholder: 'Cerca progetti, attività, sprint...',
        noResults: 'Nessun risultato trovato',
        projects: 'Progetti',
        tasks: 'Attività',
        sprints: 'Sprint',
        epics: 'Epic',
    },
    notifications: {
        title: 'Notifiche',
        markAllRead: 'Segna tutte come lette',
        clearAll: 'Cancella tutte',
        empty: 'Nessuna notifica',
        unread: '{count} non lette',
    },
    dashboard: {
        totalProjects: 'Progetti totali',
        totalTasks: 'Attività totali',
        completion: 'Completamento',
        statusBreakdown: 'Ripartizione stati',
        createProject: 'Crea progetto',
        loadSeedData: 'Carica dati di esempio',
        noProjects: 'Nessun progetto ancora',
        getStarted: 'Inizia creando un nuovo progetto o caricando dati di esempio.',
        projects: 'Progetti',
        newProject: 'Nuovo progetto',
        createNewProject: 'Crea nuovo progetto',
        projectName: 'Nome progetto',
        description: 'Descrizione',
        workflow: 'Flusso di lavoro',
        skipToMain: 'Vai al contenuto principale',
        projectProgress: 'Avanzamento progetto',
        quickActions: 'Quick Actions',
        manageTasks: 'Manage tasks and track progress',
        trackTime: 'Track time for your tasks',
    },
    calendar: {
        jalali: 'Jalali',
        hijri: 'Hijri',
        gregorian: 'Gregoriano',
    },
    accessibility: {
        skipToMain: 'Vai al contenuto principale',
        board: 'Board attività',
        projectList: 'Lista progetti',
        mainNav: 'Navigazione principale',
        selectTheme: 'Seleziona tema',
        projectDashboard: 'Pannello progetto',
        toggleSidebar: 'Toggle sidebar',
    },
    board: {
        title: 'Board',
        kanban: 'Kanban',
        scrum: 'Scrum',
    },
    task: {
        title: 'Attività',
        createTask: 'Crea attività',
        editTask: 'Modifica attività',
        deleteTask: 'Elimina attività',
        assignee: 'Assegnatario',
        unassigned: 'Non assegnato',
        storyPoints: 'Punti storia',
        labels: 'Etichette',
        description: 'Descrizione',
        acceptanceCriteria: 'Criteri di accettazione',
        timeLog: 'Registro tempo',
        comments: 'Commenti',
        addComment: 'Aggiungi commento',
        noComments: 'Nessun commento ancora',
        status: 'Stato',
        priority: 'Priorità',
        created: 'Creato',
        updated: 'Aggiornato',
        started: 'Iniziato',
    },
    sprint: {
        title: 'Sprint',
        createSprint: 'Crea sprint',
        sprintGoal: 'Obiettivo sprint',
        committedPoints: 'Punti impegnati',
        completedPoints: 'Punti completati',
        velocity: 'Velocità',
        planned: 'Pianificato',
        inProgress: 'In corso',
        completed: 'Completato',
    },
    team: {
        title: 'Team',
        members: 'Membri',
        role: 'Ruolo',
        availability: 'Disponibilità',
        assignedTasks: 'Attività assegnate',
        activeTasks: 'Attività attive',
        doneTasks: 'Attività completate',
    },
    timeTracking: {
        title: 'Gestione del tempo',
        timer: 'Timer',
        manualEntry: 'Inserimento manuale',
        startTime: 'Ora di inizio',
        stopTime: 'Ora di fine',
        duration: 'Durata',
        date: 'Data',
        totalHours: 'Ore totali',
        entries: 'Voci',
        noEntries: 'Nessuna voce ancora',
        hours: 'Hours',
        minutes: 'Minutes',
    },
    admin: {
        dashboard: 'Pannello amministrazione',
        projects: 'Progetti',
        totalTasks: 'Attività totali',
        storyPoints: 'Punti storia',
        taskStatusBreakdown: 'Ripartizione stati attività',
        projectProgress: 'Avanzamento progetto',
        teamWorkload: 'Carico di lavoro del team',
        assigned: 'Assegnate',
        active: 'Attive',
    },
    myTasks: {
        title: 'Le mie attività',
        total: 'Totale',
        inProgress: 'In corso',
        inReview: 'In revisione',
        done: 'Completate',
        completion: 'Completamento',
        allStatus: 'Tutti gli stati',
        allProjects: 'Tutti i progetti',
        noTasksAssigned: 'Nessuna attività assegnata a te',
    },
    activity: {
        title: 'Feed attività',
        commentsOnYourTasks: 'Commenti alle tue attività',
        allActivity: 'Tutte le attività',
        noActivityYet: 'Nessuna attività ancora',
        commentedOn: 'ha commentato su',
        movedTo: 'spostato a',
    },
    profile: {
        title: 'Profilo',
        avatar: 'Avatar',
        dragDropImage: 'Trascina e rilascia un\'immagine qui, o sfoglia i file',
        browse: 'Sfoglia',
        imageFormats: 'PNG, JPG, WEBP fino a 2 MB',
        removePhoto: 'Rimuovi foto',
        saveChanges: 'Salva modifiche',
        profileSaved: 'Profilo salvato',
        contactAdmin: 'Contatta l\'amministratore per modifiche al ruolo',
    },
};
//# sourceMappingURL=it.js.map